import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  grid-gap: 10px;
  user-select: none;
`;

export const ContentFilters = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1em 0;
  align-items: center;
`;

export const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.neutral.white,
    marginBottom: "10px",
  },
}));
